module.exports = __webpack_public_path__ + "img/fzds4.7a0f48f6.png";